module.exports = __webpack_public_path__ + "media/images/news-5-96adc67302b267eea670e49005e017fd.jpg";